/* Box configurator: reads the box data embedded in the page and keeps the price summary in sync.
   Surprise level = the pool the shirt is drawn from (per box). Teams to avoid = separate, optional. */
(function () {
  var root = document.getElementById('box-configurator');
  var dataEl = document.getElementById('box-data');
  if (!root || !dataEl) return;
  var data = JSON.parse(dataEl.textContent);
  // Liquid's `t` filter HTML-escapes every translation, so the JSON carries
  // "that&#39;s" where the locale file says "that's". Decode the copy once
  // here: it is shown through textContent and sent as line item properties,
  // both of which take text, not HTML. Variants and URLs are left alone.
  var decode = (function () {
    var ta = document.createElement('textarea');
    return function (s) { ta.innerHTML = s; return ta.value; };
  })();
  (function walk(o) {
    for (var k in o) {
      if (typeof o[k] === 'string') o[k] = decode(o[k]);
      else if (o[k] && typeof o[k] === 'object') walk(o[k]);
    }
  })({ box: data.box, addons: data.addons, tiers: data.tiers, strings: data.strings });
  var esc = function (s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  };
  var box = data.box, addons = data.addons;

  // the campaign's own state, written by the layout
  var promo = (function () {
    var el = document.getElementById('promo-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  })();

  // Shopify sends money in cents and a cart endpoint; the static prototype sends
  // euros and no endpoint. One file serves both.
  var shopify = !!data.cart_add_url;
  var eur = function (n) {
    if (shopify) n = n / 100;
    return '€' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '').replace('.', ',');
  };
  // Shopify renders the copy through the locale files; the static prototype has
  // no Liquid, so the English defaults below stand in.
  var S = data.strings || {};
  var EN = {
    price_note: 'per box · incl. VAT, excl. shipping', price_note_multi: 'per box · {n} boxes',
    per_shirt: 'shirt', box_line: 'box', level_line: 'Surprise level',
    bundle_discount: 'Bundle discount {pct}%', you_save: 'You save vs. list price', total: 'Total',
    avoid_hint: 'Optional. Skip leagues or specific clubs',
    leagues_selected: '{n} / {max} selected', leagues_max: 'Select up to {max} leagues',
    leagues_skipped: '{n} league skipped', leagues_skipped_plural: '{n} leagues skipped',
    clubs_noted: 'clubs noted', friend_added: "friend's order added",
    select_size: 'Pick a size first', combo_unavailable: 'That combination is not available.',
    added: 'Added to cart', error: 'Something went wrong. Please try again.',
    prop_level: 'Surprise level', prop_leagues: 'Leagues to avoid',
    prop_clubs: 'Clubs to avoid', prop_friend: "Friend's order"
  };
  // both token styles are accepted: Liquid's {{ count }} and the plain {n} used
  // by the strings the theme interpolates in the browser
  var t = function (key, vars) {
    var out = S[key] || EN[key] || '';
    for (var k in (vars || {})) {
      out = out.split('{' + k + '}').join(vars[k])
               .split('{{ ' + k + ' }}').join(vars[k]);
    }
    return out.replace(/\{\{\s*\w+\s*\}\}/g, '');
  };
  var variants = data.variants || [];
  // The store translates option values, so an add-on set is matched to a
  // Customization value by its position, not its text: cust_map lists, in value
  // order, the add-ons each value stands for.
  var custMap = data.cust_map || [];
  var sameSet = function (a, b) {
    return a.length === b.length && a.every(function (x) { return b.indexOf(x) !== -1; });
  };
  var custIndexFor = function (list) {
    for (var i = 0; i < custMap.length; i++) {
      if (sameSet(custMap[i], list)) return i;
    }
    return -1;
  };
  var variantFor = function (size, list) {
    var want = custMap.length ? custIndexFor(list) : 0;
    if (want === -1) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if ((v.cust_index || 0) !== want) continue;
      if (size && v.size && v.size !== size) continue;
      return v;
    }
    return null;
  };
  var q = function (sel) { return root.querySelector(sel); };
  var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  function state() {
    var tier = q('input[name="bx-qty"]:checked');
    return {
      qty: tier ? parseInt(tier.value, 10) : 1,
      discount: tier ? parseFloat(tier.getAttribute('data-discount')) : 0,
      addons: qa('input[name="bx-addon"]:checked').map(function (el) { return el.value; })
    };
  }
  function perShirt(s) {
    if (shopify) {
      var size = q('input[name="bx-size"]:checked');
      var v = variantFor(size ? size.value : null, s.addons);
      if (v) return v.price;
    }
    var b = box.price;
    s.addons.forEach(function (k) { if (addons[k]) b += addons[k].price; });
    return b;
  }

  function render() {
    var s = state(), full = perShirt(s), per = full * (1 - s.discount / 100), total = per * s.qty, listTotal = box.compare * s.qty;
    q('[data-bx="price-now"]').textContent = eur(per);
    q('[data-bx="price-was"]').textContent = box.compare > full ? eur(box.compare) : '';
    q('[data-bx="price-note"]').textContent = s.qty > 1 ? t('price_note_multi', { n: s.qty, count: s.qty }) : t('price_note');
    qa('.bx_tier').forEach(function (tier) {
      var d = parseFloat(tier.querySelector('input').getAttribute('data-discount'));
      tier.querySelector('.bx_tier_per').textContent = eur(full * (1 - d / 100)) + ' / ' + t('per_shirt');
    });
    var name = box.name || (box.short + ' ' + t('box_line'));
    var html = '<div class="bx_line"><span>' + esc(name) + ' × ' + s.qty + '</span><span>' + eur(box.price * s.qty) + '</span></div>';
    var lvl = q('[data-bx="level"]');
    if (lvl) html += '<div class="bx_line"><span>' + esc(t('level_line')) + '</span><span>' + esc(box.levels[parseInt(lvl.value, 10)].label) + '</span></div>';
    s.addons.forEach(function (k) { html += '<div class="bx_line"><span>' + esc(addons[k].label) + ' × ' + s.qty + '</span><span>+ ' + eur(addons[k].price * s.qty) + '</span></div>'; });
    if (s.discount) html += '<div class="bx_line is-save"><span>' + esc(t('bundle_discount', { pct: s.discount, percent: s.discount })) + '</span><span>− ' + eur(full * s.qty - total) + '</span></div>';
    if (listTotal > total && !s.addons.length) html += '<div class="bx_line is-save"><span>' + esc(t('you_save')) + '</span><span>' + eur(listTotal - total) + '</span></div>';
    html += '<div class="bx_line is-total"><span>' + esc(t('total')) + '</span><span>' + eur(total) + '</span></div>';
    q('[data-bx="lines"]').innerHTML = html;
    q('[data-bx="cta-total"]').textContent = eur(total);
    if (shopify) {
      // an add-on is offered only if the resulting combination exists as a variant
      var size = q('input[name="bx-size"]:checked');
      qa('input[name="bx-addon"]').forEach(function (el) {
        var next = s.addons.slice();
        var at = next.indexOf(el.value);
        if (at === -1) { next.push(el.value); } else { next.splice(at, 1); }
        el.disabled = !variantFor(size ? size.value : null, next);
      });
    } else {
      var ls = q('input[name="bx-addon"][value="long_sleeves"]'), pr = q('input[name="bx-addon"][value="printing"]');
      if (ls && pr) { pr.disabled = ls.checked; ls.disabled = pr.checked; }
    }
  }

  // surprise level: description follows the selected pool
  function renderLevel() {
    var sel = q('[data-bx="level"]'); if (!sel) return;
    var i = parseInt(sel.value, 10), lvl = box.levels[i];
    q('[data-bx="level-desc"]').textContent = lvl ? lvl.desc : '';
    sel.setAttribute('aria-valuetext', lvl ? lvl.label : '');
    qa('.bx_level_labels span').forEach(function (el, k) { el.classList.toggle('is-on', k === i); });
  }

  // teams to avoid: expandable panel with its own summary
  function avoidSummary() {
    var leagues = qa('input[name="bx-league"]:checked').length;
    var clubs = (q('[data-bx="teams-input"]').value || '').trim();
    var friend = (q('[data-bx="friend-input"]').value || '').trim();
    var parts = [];
    if (leagues) parts.push(t(leagues === 1 ? 'leagues_skipped' : 'leagues_skipped_plural', { n: leagues, count: leagues }));
    if (clubs) parts.push(t('clubs_noted'));
    if (friend) parts.push(t('friend_added'));
    var hint = q('[data-bx="avoid-summary"]');
    hint.textContent = parts.length ? parts.join(' · ') : t('avoid_hint');
    hint.classList.toggle('is-set', parts.length > 0);
  }
  function renderLeagues() {
    var checked = qa('input[name="bx-league"]:checked'), max = data.max_excluded_leagues;
    q('[data-bx="league-count"]').textContent = checked.length
      ? t('leagues_selected', { n: checked.length, max: max, count: checked.length })
      : t('leagues_max', { max: max, count: max });
    qa('input[name="bx-league"]').forEach(function (el) { el.disabled = !el.checked && checked.length >= max; });
    avoidSummary();
  }
  function toggleAvoid(open) {
    var btn = q('[data-bx="avoid-toggle"]'), panel = q('[data-bx="excl"]');
    var willOpen = typeof open === 'boolean' ? open : panel.hidden;
    panel.hidden = !willOpen; btn.setAttribute('aria-expanded', String(willOpen));
  }

  root.addEventListener('change', function (e) {
    if (e.target.name === 'bx-league') renderLeagues();
    if (e.target.getAttribute('data-bx') === 'level') renderLevel();
    render();
  });
  root.addEventListener('input', function (e) {
    var k = e.target.getAttribute('data-bx');
    if (k === 'level') { renderLevel(); render(); }
    if (k === 'teams-input' || k === 'friend-input') avoidSummary();
  });
  q('[data-bx="avoid-toggle"]').addEventListener('click', function () { toggleAvoid(); });
  q('[data-bx="avoid-apply"]').addEventListener('click', function () { avoidSummary(); toggleAvoid(false); q('[data-bx="avoid-toggle"]').focus(); });

  q('[data-bx="cta"]').addEventListener('click', function () {
    var s = state(), size = q('input[name="bx-size"]:checked'), lvl = q('[data-bx="level"]');
    var summary = {
      box: box.slug, qty: s.qty, size: size ? size.value : null, surprise_level: lvl ? box.levels[parseInt(lvl.value, 10)].id : null, addons: s.addons,
      excluded_leagues: qa('input[name="bx-league"]:checked').map(function (el) { return el.value; }),
      avoid_clubs: (q('[data-bx="teams-input"]').value || '').trim(),
      friend_order: (q('[data-bx="friend-input"]').value || '').trim()
    };
    var msg = q('[data-bx="msg"]');
    var cta = q('[data-bx="cta"]');
    if (box.has_sizes && !size) { msg.textContent = t('select_size'); msg.hidden = false; return; }

    if (!shopify) {
      msg.textContent = 'Prototype: this is where the cart takes over. Selection: ' + JSON.stringify(summary);
      msg.hidden = false;
      return;
    }

    var variant = variantFor(size ? size.value : null, s.addons);
    if (!variant) { msg.textContent = t('combo_unavailable'); msg.hidden = false; return; }

    // the choices that are not variants travel as line item properties
    var props = {};
    if (summary.surprise_level) {
      props[t('prop_level')] = box.levels[parseInt(lvl.value, 10)].label;
    }
    if (summary.excluded_leagues.length) props[t('prop_leagues')] = summary.excluded_leagues.join(', ');
    if (summary.avoid_clubs) props[t('prop_clubs')] = summary.avoid_clubs;
    if (summary.friend_order) props[t('prop_friend')] = summary.friend_order;

    // The campaign's free shirt is not a product, a variant or a discount: it
    // is one attribute on this line, which is the only thing that reaches
    // fulfilment unchanged. The price does not move; the second shirt rides
    // along as an instruction.
    //
    // The line carries a quantity, so three boxes is ONE attribute on a line of
    // three, meaning three free shirts. Anything counting them downstream has
    // to multiply by the line quantity rather than count attributes.
    //
    // The gate is the campaign's own allowlist and its own end date, read from
    // its own config. It deliberately does not consult a site-wide promo
    // switch: a shared flag turning off elsewhere would stop the shirts while
    // the campaign page kept selling them.
    if (promo && promo.active && promo.on_page &&
        (promo.boxes || []).indexOf(box.handle) > -1) {
      props[promo.attr] = promo.value;
    }

    var body = { items: [{ id: variant.id, quantity: s.qty, properties: props }] };
    var label = cta.innerHTML;
    cta.disabled = true;
    msg.hidden = true;
    fetch(data.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) { return r.json().then(function (e) { throw new Error(e.description || e.message || r.status); }); }
      return r.json();
    }).then(function () {
      msg.textContent = t('added');
      msg.hidden = false;
      document.dispatchEvent(new CustomEvent('ms:cart:added', { detail: { variant: variant.id, quantity: s.qty } }));
      // which landing page actually sold this, on the order rather than the
      // line. Different from first-touch attribution, which can point at a
      // page the cart was never built on.
      var go = function () { window.location.href = data.cart_url; };
      if (promo && promo.funnel_attr) {
        // Cart attributes outlive the lines: emptying a cart does not clear
        // them. Without the else branch a visitor who built a cart here, threw
        // it away and then bought through the normal funnel would still arrive
        // as a campaign sale. So every add writes the funnel it was actually
        // made from, and clears it when that is not the campaign. Sending one
        // key leaves any other cart attribute alone.
        var onCampaign = promo.active && promo.on_page;
        var attrs = {};
        attrs[promo.funnel_attr] = onCampaign ? promo.slug : '';
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        }).then(go, go);
      } else { go(); }
    }).catch(function (err) {
      msg.textContent = t('error') + ' (' + err.message + ')';
      msg.hidden = false;
    }).then(function () {
      cta.disabled = false;
      cta.innerHTML = label;
    });
  });

  renderLevel(); renderLeagues(); render();
})();
